import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class LocationTypeOtherExcludeInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const modRequest = request.clone({ body: request.body });

    const locationTypeRegex = /.+\/location-types([?].+=.+&?)?$/;

    if (locationTypeRegex.test(request.url)) {
      return next.handle(modRequest).pipe(
        tap((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            event.body.data = event.body.data.filter((d) => d.code != 'other');
          }
        })
      );
    } else if ((request.body as any)?.operationName == 'locationTypes') {
      return next.handle(modRequest).pipe(
        tap((event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
            event.body.data.locationTypes.data = event.body?.data?.locationTypes?.data?.filter((d) => d.code != 'other');
          }
        })
      );
    }

    return next.handle(request);
  }
}
